module.exports = __webpack_public_path__ + "media/images/payment_banner-eb49979ed48c7f45e09da38a61c1887e.png";